import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { checkAuth } from 'data/usecases/check-auth';
import { checkExperience } from 'data/usecases/check-experience';

import { Routes } from 'presentation/routes/routes';
import { AppProvider } from 'presentation/hooks';
import 'presentation/styles/global.scss';

import { environment } from 'utils/environment.utils';

const App = (): JSX.Element => {

    checkAuth();
    checkExperience();

    return (
        <AppProvider>
            <Router basename={environment.APP_BASE_NAME}>
                <Routes />
            </Router>
        </AppProvider>

    );
};

export default App;
